<div class="tml-tpl-wrap">
    <div *ngFor="let section of config" class="setcion-control"
        [ngClass]="{'control-border':section.sectionName === sectionName}">
        <div *ngIf="!section.isHidden" class="template-label" [ngClass]="section.sectionId">
            <label>
                {{section.sectionName}}</label>
        </div>
        <div>
            <div class="tml-tpl-row" *ngFor="let rowlabel of section.container">
                <div class="tml-tpl-cell" *ngFor="let childConfig of rowlabel">
                    <div attr.tid="{{childConfig.config.controlName}}" class="template-ctrl" #contentElement>
                        <div class="tml-tpl-label"
                            *ngIf="!childConfig.config.isLabelHidden&&childConfig.config.controlType!=='divider'">
                            <label>{{childConfig.config.controlName}}<span *ngIf="childConfig.config.isRequired"
                                    style="color:red;">&nbsp;*</span></label>
                        </div>
                        <div [ngSwitch]="childConfig.config.controlType">
                            <div *ngSwitchCase="'input'">
                                <tam-contact-input [childConfig]="childConfig">
                                </tam-contact-input>
                            </div>
                            <div *ngSwitchCase="'alias'">
                                <tam-contact-alias [childConfig]="childConfig">
                                </tam-contact-alias>
                            </div>
                            <div *ngSwitchCase="'label'">
                                <tam-contact-label [childConfig]="childConfig">
                                </tam-contact-label>
                            </div>
                            <div *ngSwitchCase="'divider'">
                                <tam-contact-divider [childConfig]="childConfig">
                                </tam-contact-divider>
                            </div>
                            <div *ngSwitchCase="'dropdown'">
                                <tam-contact-dropdown [childConfig]="childConfig">
                                </tam-contact-dropdown>
                            </div>
                            <div *ngSwitchCase="'singleDropdown'">
                                <tam-contact-single-dropdown [childConfig]="childConfig">
                                </tam-contact-single-dropdown>
                            </div>
                            <div *ngSwitchCase="'med-input'">
                                <tam-contact-med [childConfig]="childConfig">
                                </tam-contact-med>
                            </div>
                            <div *ngSwitchCase="'msd-input'">
                                <tam-contact-msd [childConfig]="childConfig">
                                </tam-contact-msd>
                            </div>
                            <div *ngSwitchCase="'job-function'">
                                <tam-contact-job-function [childConfig]="childConfig">
                                </tam-contact-job-function>
                            </div>
                            <div *ngSwitchCase="'date'">
                                <tam-contact-date [childConfig]="childConfig">
                                </tam-contact-date>
                            </div>
                            <div *ngSwitchCase="'textarea'">
                                <tam-contact-area [childConfig]="childConfig">
                                </tam-contact-area>
                            </div>
                            <div *ngSwitchCase="'combine-dropdown-input'">
                                <tam-contact-combine-dropdown-input [childConfig]="childConfig">
                                </tam-contact-combine-dropdown-input>
                            </div>
                            <div *ngSwitchCase="'combine-address'">
                                <tam-contact-address [childConfig]="childConfig">
                                </tam-contact-address>
                            </div>
                            <div *ngSwitchCase="'Former-Employment'">
                                <tam-contact-former-employment [childConfig]="childConfig">
                                </tam-contact-former-employment>
                            </div>
                            <div *ngSwitchCase="'Combine-CurrentEmployment'">
                                <tam-contact-current-employment [childConfig]="childConfig">
                                </tam-contact-current-employment>
                            </div>
                            <div *ngSwitchCase="'Combine-Relationships'">
                                <tam-contact-more-relationship [childConfig]="childConfig">
                                </tam-contact-more-relationship>
                            </div>
                        </div>
                        <smart-icon name="trash" class="trash-icon" *ngIf="childConfig.config.isRemoved&&isSelected"
                            (click)="clickTrash($event,childConfig.config.controlName)"></smart-icon>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>